function HomeStructureRequestTransformer(
	jsonMapper,
	util,
	quoteOptions,
	storage
) {
	var structureQuoteMapping = {
		periodStartDate: "=_input.homeForm.letsGetStarted.startCoverDate",
		dwellings: [],
		"dwellings.0": {},
		"dwellings.0.location": "=_addressSearch",
		"dwellings.0.buildingType":
			"=_input.homeForm.tellUsAboutTheProperty.typeOfBuilding",
		"dwellings.0.externalWallMaterial":
			"=_input.homeForm.tellUsAboutTheProperty.wallsMadeOf",
		"dwellings.0.homeOccupancy":
			"=_input.homeForm.tellUsAboutTheProperty.howIsHomeOccupied",
		"dwellings.0.buildingSumInsured":
			"=_input.homeForm.rapidEstimate.buildingInsureAmount",
		"dwellings.0.contentSumInsured":
			"=_input.homeForm.rapidEstimate.contentInsureAmount",

		"dwellings.0.policyOption": {},
		"dwellings.0.policyOption.rentDefaultAmount":
			"=_input.homeForm.rapidEstimate.rentDefaultCoverAmount",
		"dwellings.0.policyOption.rentDefaultWeeks":
			"=_input.homeForm.rapidEstimate.uptoWeeks",
		"dwellings.0.policyOption.isPropertyAgentManaged":
			"=_input.homeForm.tellUsAboutTheProperty.propertyProfessionalAgent",

		"dwellings.0.yearsContInsurance":
			"=_input.homeForm.insuranceHistory.insuranceHeldFor",
		"dwellings.0.previousInsurer":
			"=_input.homeForm.insuranceHistory.previousInsurer",
		"dwellings.0.hasInsuredClaims":
			"=_input.homeForm.insuranceHistory.claimInLastYear",

		"dwellings.0.dwellingHistories": [],

		//multiple data for portable and other contents
		"dwellings.0.dwellingClaimHistories":
			"=_input.homeForm.insuranceHistory.claimDetails",

		"dwellings.0.dwellingPortableClaimHistories":
			"=_input.homeForm.insuranceHistory.portableClaimDetails",

		"dwellings.0.homeBuiltYear":
			"=_input.homeForm.tellUsAboutTheBuilding.yearHomeBuilt",
		"dwellings.0.isStrataRegisteredBody":
			"=_input.homeForm.tellUsAboutTheBuilding.isStrataRegdCorp",
		"dwellings.0.isUnitsAvailable":
			"=_input.homeForm.tellUsAboutTheBuilding.areUnitAboveBelow",
		"dwellings.0.isOwnersInsureUnits":
			"=_input.homeForm.tellUsAboutTheBuilding.corpInsureUnit",
		"dwellings.0.isSubUrbanLocated":
			"=_input.homeForm.tellUsAboutTheBuilding.isSuburbanBlock",
		"dwellings.0.isPropertySize":
			"=_input.homeForm.tellUsAboutTheBuilding.isBlockLarger",
		"dwellings.0.waterSourced":
			"=_input.homeForm.tellUsAboutTheBuilding.waterSource",
		"dwellings.0.waterTankCapacity":
			"=_input.homeForm.tellUsAboutTheBuilding.waterTankCapacity",
		"dwellings.0.isSecondaryFitted":
			"=_input.homeForm.tellUsAboutTheBuilding.isEmergencyFuelWaterTank",
		"dwellings.0.isCaravanHomeLocated":
			"=_input.homeForm.tellUsAboutTheBuilding.isBuildingRelocatable",
		"dwellings.0.isSecuredFoundation":
			"=_input.homeForm.tellUsAboutTheBuilding.areFoundationsSecured",
		"dwellings.0.isPlumbingConnect":
			"=_input.homeForm.tellUsAboutTheBuilding.isFixedPlumbingElectricityConnect",
		"dwellings.0.roofMaterial":
			"=_input.homeForm.tellUsAboutTheBuilding.roofMake",
		"dwellings.0.groundElevated":
			"=_input.homeForm.tellUsAboutTheBuilding.isHomeElevated",
		"dwellings.0.homeLevels":
			"=_input.homeForm.tellUsAboutTheBuilding.homeLevels",
		"dwellings.0.isUnitAboveGround":
			"=_input.homeForm.tellUsAboutTheBuilding.isUnitAboveGround",
		//IMPORTANT: Setting isPortionBelowGround to isPortionAboveGround is intentional as this is how it is mapped in guide-wire
		"dwellings.0.isPortionAboveGround":
			"=_input.homeForm.tellUsAboutTheBuilding.isPortionBelowGround",
		// "dwellings.0.isPortionAboveGround" : "=_input.homeForm.tellUsAboutTheBuilding.areContentsBelowGround",
		"dwellings.0.isNationalTrustListed":
			"=_input.homeForm.tellUsAboutTheBuilding.isNationalTrustListed",
		"dwellings.0.isFullyRewired":
			"=_input.homeForm.tellUsAboutTheBuilding.isHomeWired",

		//Theft and vandalism by tenants
		"dwellings.0.policyOption.isBuildingVandalismCover":
			"=_input.homeForm.theftAndVandalismByTenants.theftCoverBuilding",
		"dwellings.0.policyOption.isContentVandalismCover":
			"=_input.homeForm.theftAndVandalismByTenants.theftCoverContents",

		// Tell us About the Security Section
		"dwellings.0.locationSecurity": {},
		"dwellings.0.locationSecurity.hasDoorDeadlocks":
			"=_input.homeForm.tellUsAboutTheSecurity.securityExternalDoors.deadlocks",
		"dwellings.0.locationSecurity.hasDoorSecurityScreen":
			"=_input.homeForm.tellUsAboutTheSecurity.securityExternalDoors.door_security_screen",

		"dwellings.0.locationSecurity.hasWindowKeylocks":
			"=_input.homeForm.tellUsAboutTheSecurity.securityExternalWindows.keylocks",
		"dwellings.0.locationSecurity.hasWindowRollerShutter":
			"=_input.homeForm.tellUsAboutTheSecurity.securityExternalWindows.roller_shutter",
		"dwellings.0.locationSecurity.hasWindowScreenBars":
			"=_input.homeForm.tellUsAboutTheSecurity.securityExternalWindows.security_screens_or_bars",

		"dwellings.0.locationSecurity.isGatedCommunity":
			"=_input.homeForm.tellUsAboutTheSecurity.otherSecurity.gated_community",
		"dwellings.0.locationSecurity.has24HourConcierge":
			"=_input.homeForm.tellUsAboutTheSecurity.otherSecurity.24_hour_concierge",
		"dwellings.0.locationSecurity.hasFixedHomeSafe":
			"=_input.homeForm.tellUsAboutTheSecurity.otherSecurity.fixed_home_sage",
		"dwellings.0.locationSecurity.isSecurityRatedBuilding":
			"=_input.homeForm.tellUsAboutTheSecurity.otherSecurity.security_rated_building",

		//Renovations and Residents
		"dwellings.0.isRenovated":
			"=_input.homeForm.renovationsAndResidents.isHomeUnderRepairs",
		"dwellings.0.isCommunitySurrounded":
			"=_input.homeForm.renovationsAndResidents.isHomeInCommunity",
		"dwellings.0.isUnrelatedPeople":
			"=_input.homeForm.renovationsAndResidents.areUnrelatedPeopleInHome",

		//Property Usage
		"dwellings.0.isIncomeGenerated":
			"=_input.homeForm.propertyUsage.isPropertyForBusiness",
		"dwellings.0.incomeGeneratingDegree":
			"=_input.homeForm.propertyUsage.propertyActivityDegree",
		"dwellings.0.incomeGeneratingActivities":
			"=_input.homeForm.propertyUsage.propertyActivities",
		"dwellings.0.agriculturalActivities":
			"=_input.homeForm.propertyUsage.propertyAgricultureActivities",

		//Mortgage on Property
		"dwellings.0.isMortgagePresent":
			"=_input.homeForm.mortgageOnProperty.isPropertyUnderMortgage",

		//Building step
		//Building Details
		"dwellings.0.locationProperty": {},
		"dwellings.0.locationProperty.homeStandard":
			"=_input.homeForm.buildingDetails.homeBuiltStandard",
		"dwellings.0.locationProperty.isLandSloped":
			"=_input.homeForm.buildingDetails.landSlope",
		"dwellings.0.locationProperty.knowHomeSize":
			"=_input.homeForm.buildingDetails.homeTotalArea",
		"dwellings.0.locationProperty.sizeOfHome":
			"=_input.homeForm.buildingDetails.homeArea",
		"dwellings.0.locationProperty.areaUnit":
			"=_input.homeForm.buildingDetails.homeAreaUnit",
		"dwellings.0.locationProperty.sizeOfBedroom":
			"=_input.homeForm.buildingDetails.homeBedroomSize",
		"dwellings.0.isCycloneStandardlyBuilt":
			"=_input.homeForm.buildingDetails.isBuiltToCycloneStandards",

		/** These need to be be commented back in and converted to guide-wire expected values */

		"dwellings.0.locationProperty.numberOfBedrooms":
			"=_input.homeForm.buildingDetails.homeBedrooms",
		"dwellings.0.locationProperty.numberOfBalconies":
			"=_input.homeForm.buildingDetails.homeDecks",
		"dwellings.0.locationProperty.numberOfVerandahs":
			"=_input.homeForm.buildingDetails.homeVerandahs",
		"dwellings.0.locationProperty.numberOfCarports":
			"=_input.homeForm.buildingDetails.homeCarports",
		"dwellings.0.locationProperty.numberOfGarages":
			"=_input.homeForm.buildingDetails.homeGarages",
		"dwellings.0.locationProperty.hasSheds":
			"=_input.homeForm.buildingDetails.homeSheds",

		"dwellings.0.locationProperty.numberOfLargeSheds":
			"=_input.homeForm.buildingDetails.largeSheds",
		"dwellings.0.locationProperty.numberOfSmallSheds":
			"=_input.homeForm.buildingDetails.smallSheds",

		"dwellings.0.locationProperty.hasDuctedAirConditioning":
			"=_input.homeForm.buildingDetails.homeFeatures.ducted_airconditioning",
		"dwellings.0.locationProperty.hasInGroundPool":
			"=_input.homeForm.buildingDetails.homeFeatures.in_ground_swimming_pool",
		"dwellings.0.locationProperty.hasTennisCourt":
			"=_input.homeForm.buildingDetails.homeFeatures.tennis_court",
		"dwellings.0.locationProperty.hasGrannyFlat":
			"=_input.homeForm.buildingDetails.homeFeatures.granny_flat",
		"dwellings.0.locationProperty.grannyFlatSize":
			"=_input.homeForm.buildingDetails.grannyFlatSize",

		//Covers Step
		//Your building
		"dwellings.0.buildingSumInsured":
			"=_input.homeForm.yourBuilding.buildingSumInsured",

		//Your contents
		"dwellings.0.contentSumInsured":
			"=_input.homeForm.yourContents.contentsSumInsured",

		//Portable Contents
		"dwellings.0.hasPortableContentsHomeAway":
			"=_input.homeForm.portableContents.coverPortableContents",
		"dwellings.0.portableCoverCountry":
			"=_input.homeForm.portableContents.coverPortableContentsRegion",
		"dwellings.0.generalPortableContents":
			"=_input.homeForm.portableContents.coverPortableContentLimit",
		"dwellings.0.hasSpecifiedPortableContList":
			"=_input.homeForm.portableContents.portableContentsSpecifiedCover",
		"dwellings.0.hasGeneralPortableContents":
			"=_input.homeForm.portableContents.coverPortableContents",
		//Accidental Loss or Damage
		"dwellings.0.policyOption.isBuildingAccidentalDamage":
			"=_input.homeForm.accidentalLossOrDamage.coverAccDmgBuilding",
		"dwellings.0.policyOption.isContentsAccidentalDamage":
			"=_input.homeForm.accidentalLossOrDamage.coverAccDmgContents",

		//Cycle Cover
		"dwellings.0.policyOption.isContentsCycleCover":
			"=_input.homeForm.cycleCover.coverCycle",
		"dwellings.0.policyOption.isContentsCycleRacingCover":
			"=_input.homeForm.cycleCover.coverCycleExtendOption",
		"dwellings.0.policyOption.specifyCycleEquipment":
			"=_input.homeForm.cycleCover.coverItems",

		//Rent Default
		"dwellings.0.policyOption.isRentDefaultCover":
			"=_input.homeForm.rentDefault.rentDefault",

		"dwellings.0.excess": {},
		"dwellings.0.excess.voluntaryExcess":
			"=_input.homeForm.chooseYourExcess.homeExcess",
		"dwellings.0.excess.portableContentVoluntaryExcess":
			"=_input.homeForm.chooseYourExcess.portableContentsExcess",

		//Specified High Risk Items
		"dwellings.0.hasWorksArt":
			"=_input.homeForm.specifiedHighRiskItems.riskCoverIndividualWorks",
		"dwellings.0.hasEntertainmentEquipment":
			"=_input.homeForm.specifiedHighRiskItems.riskEntertainmentEquipment",

		//Domestic Worker's compensation
		"dwellings.0.policyOption.isContentsDomesticWorkerComp":
			"=_input.homeForm.domesticWorkerCompensation.domesticWorkerCompCover",

		//quote steps
		"dwellings.0.offering":
			"=_input.homeForm.confirmYourLevelOfCover.yourChosenCover",

		//Contact Step
		policyHolders: [],
		"policyHolders.0": {},
		"policyHolders.0.contact": {},
		"policyHolders.0.contact.primaryAddress": "=_addressSearch",
		"policyHolders.0.contact.dateOfBirth":
			"=_input.homeForm.tellUsAboutInsured.dobOldestInsured",
		policyAddress: "=_addressSearch",
		"policyHolders.0.contact.primaryAddress.addressType": "residential",
		"policyAddress.addressType": "residential",
		isInsuredsRetired: "=_input.homeForm.tellUsAboutInsured.isRetired",
		hasPortableContentsClaims:
			"=_input.homeForm.insuranceHistory.portableClaim",
		email: "=_input.email",
		campaignCode: "=_input.homeForm.tellUsABitMore.promotionalCode",
		postalAddress: "=_addressSearch-postal-address",
	};

	function updatePolicyHolderPrimaryAddress(transformedRequest) {
		var policyHolder = util.deepClone(transformedRequest.policyHolders[0]);

		policyHolder.contact.primaryAddress.addressType = "residential";

		transformedRequest.policyHolders[0] = policyHolder;

		return transformedRequest;
	}

	function updateProductCode(transformedRequest, userInput) {
		//update productCode if rented
		if (
			userInput.homeForm &&
			userInput.homeForm.tellUsAboutTheProperty &&
			userInput.homeForm.tellUsAboutTheProperty.howIsHomeOccupied
		) {
			var landlordConditions = [
				"own_rent_tenants",
				"own_rent_tenants_causalbasis",
				"property_used_hostel_or_guest",
			];
			if (
				landlordConditions.indexOf(
					userInput.homeForm.tellUsAboutTheProperty.howIsHomeOccupied
				) > -1
			) {
				transformedRequest.productCode = "QPHLandlord";
			}
		}
		return transformedRequest;
	}

	function updateMortgagees(transformedRequest, userInput) {
		if (!userInput.homeForm && !userInput.homeForm.mortgageOnProperty) {
			return transformedRequest;
		}

		var mortgageOnProperty = userInput.homeForm.mortgageOnProperty;
		if (mortgageOnProperty.isPropertyUnderMortgage) {
			transformedRequest.dwellings[0].isMortgagePresent = true;
			var _mortgagees = [];
			mortgageOnProperty.propertyMortgagedWith.forEach(function (
				item,
				index
			) {
				var _mortgagee = {
					mortgagee: item,
					status: index + 1,
				};
				_mortgagees.push(_mortgagee);
			});
			if (_mortgagees.length > 0) {
				transformedRequest.dwellings[0].mortgagees = _mortgagees;
			} else {
				if (transformedRequest.dwellings[0].mortgagees) {
					delete transformedRequest.dwellings[0].mortgagees;
				}
			}
		} else {
			transformedRequest.dwellings[0].isMortgagePresent = false;
			if (transformedRequest.dwellings[0].mortgagees) {
				delete transformedRequest.dwellings[0].mortgagees;
			}
		}
		return transformedRequest;
	}

	function UpdateAlarmType(transformedRequest, userInput) {
		var localAlarm = false;
		var _24HourAlarm = false;

		if (
			userInput.homeForm.tellUsAboutTheSecurity &&
			userInput.homeForm.tellUsAboutTheSecurity.otherSecurity
		) {
			localAlarm =
				userInput.homeForm.tellUsAboutTheSecurity.otherSecurity[
					"local_alarm"
				];
			_24HourAlarm =
				userInput.homeForm.tellUsAboutTheSecurity.otherSecurity[
					"24_hour_monitored_alarm"
				];
		}

		transformedRequest.dwellings[0].locationSecurity.haveSecurityAlarm = false;

		var result = "";

		if (localAlarm && Boolean(localAlarm)) {
			result = "local_alarm";
			transformedRequest.dwellings[0].locationSecurity.haveSecurityAlarm = true;
		} else if (_24HourAlarm && Boolean(_24HourAlarm)) {
			result = "monitored_alarm";
			transformedRequest.dwellings[0].locationSecurity.haveSecurityAlarm = true;
		}

		transformedRequest.dwellings[0].locationSecurity.typeOfAlarm = result;
		return transformedRequest;
	}

	function UpdateRentDefault(transformedRequest, userInput) {
		// if (!userInput.homeForm.rentDefault) {
		// 	return transformedRequest;
		// }

		// var rentDefault = userInput.homeForm.rentDefault;

		// if (rentDefault.rentCurrentWeekly) {
		// 	transformedRequest.dwellings[0].policyOption.rentDefaultAmount =
		// 		rentDefault.rentCurrentWeekly;
		// }

		// if (rentDefault.rentXWeeks) {
		// 	transformedRequest.dwellings[0].policyOption.rentDefaultWeeks =
		// 		rentDefault.rentXWeeks;
		// }

		//dd-6486 - assign rent default cover to false when occupancy is rent casual basis
		if (
			transformedRequest.dwellings[0].homeOccupancy ==
			"own_rent_tenants_causalbasis"
		) {
			transformedRequest.dwellings[0].policyOption.isRentDefaultCover = false;
		}

		if (
			transformedRequest.dwellings[0].homeOccupancy ===
				"own_rent_tenants" &&
			transformedRequest.dwellings[0].policyOption
				.isPropertyAgentManaged == true
		) {
			transformedRequest.dwellings[0].policyOption.isRentDefaultCover = false;
		}

		return transformedRequest;
	}

	function updateCoverType(transformedRequest, userInput) {
		// debugger;
		if (userInput.homeForm && userInput.homeForm.tellUsHowWeCanInsureYou) {
			if (userInput.homeForm.tellUsHowWeCanInsureYou.coverNeeds) {
				var needs =
					userInput.homeForm.tellUsHowWeCanInsureYou.coverNeeds;
				if (needs.building && needs.contents) {
					transformedRequest.dwellings[0].coverType =
						"building_and_contents";
				} else if (needs.building) {
					transformedRequest.dwellings[0].coverType = "building_only";
				} else if (needs.contents) {
					transformedRequest.dwellings[0].coverType = "contents_only";
				}
			}
		}
		return transformedRequest;
	}

	function transposeMonth(monthName) {
		var months = {
			January: "01",
			February: "02",
			March: "03",
			April: "04",
			May: "05",
			June: "06",
			July: "07",
			August: "08",
			September: "09",
			October: "10",
			November: "11",
			December: "12",
		};

		return months[monthName];
	}

	function updateDwellingHistory(transformedRequest) {
		var transformedHistoryList = [];

		if (
			transformedRequest.dwellings &&
			transformedRequest.dwellings[0].hasInsuredClaims === "yes"
		) {
			var dwellingClaimHistory = transformedRequest.dwellings[0].dwellingClaimHistories.slice(
				0
			);
			dwellingClaimHistory.forEach(function (history) {
				console.log(history);
				var transformedHistory = {
					pattern: {},
					year: history.year.value,
					claimType: history.coverAffected.value,
					isPortableContents: false,
					eventMonth: transposeMonth(history.month.value),
				};
				transformedHistory.pattern = {
					publicID: history.description.publicID,
					code: history.description.code,
					description: history.description.description,
					filter1: history.description.filter1,
				};
				transformedHistoryList.push(transformedHistory);
			});
		}

		if (transformedRequest.hasPortableContentsClaims === "yes") {
			var dwellingPortableClaimHistory = transformedRequest.dwellings[0].dwellingPortableClaimHistories.slice(
				0
			);
			dwellingPortableClaimHistory.forEach(function (history) {
				console.log(history);
				var transformedHistory = {
					pattern: {},
					year: history.year.value,
					contentCategory: history.coverAffected.value,
					isPortableContents: true,

					eventMonth: transposeMonth(history.month.value),
				};
				transformedHistory.pattern = {
					publicID: history.description.publicID,
					code: history.description.code,
					description: history.description.description,
					filter1: history.description.filter1,
				};
				transformedHistoryList.push(transformedHistory);
			});
		}

		if (transformedRequest.dwellings) {
			if (
				transformedRequest.dwellings &&
				transformedHistoryList.length > 0
			) {
				transformedRequest.dwellings[0].dwellingHistories = transformedHistoryList;
			} else {
				delete transformedRequest.dwellings[0].dwellingHistories;
			}

			//removing as this is not requred by the service
			delete transformedRequest.dwellings[0].dwellingClaimHistories;
			delete transformedRequest.dwellings[0]
				.dwellingPortableClaimHistories;
		}

		return transformedRequest;
	}

	function UpdateCycles(transformedRequest, userInput) {
		if (!userInput.homeForm) {
			return transformedRequest;
		}

		if (
			userInput.homeForm.cycleCover &&
			userInput.homeForm.cycleCover.cycleList &&
			userInput.homeForm.cycleCover.cycleList.length > 0
		) {
			var cycles = [];

			userInput.homeForm.cycleCover.cycleList.forEach(function (
				cycle,
				idx
			) {
				cycles.push({
					typeOfBicycle: cycle.bikeType.value,
					description: cycle.description,
					value: cycle.value,
				});
			});

			transformedRequest.dwellings[0].policyOption.cycles = cycles;
		} else {
			delete transformedRequest.dwellings[0].policyOption.cycles;
		}

		if (
			userInput.homeForm.cycleCover &&
			userInput.homeForm.cycleCover.coverItemsList &&
			userInput.homeForm.cycleCover.coverItemsList.length > 0
		) {
			var cycleItems = [];

			userInput.homeForm.cycleCover.coverItemsList.forEach(function (
				item,
				idx
			) {
				cycleItems.push({
					category: item.category.value,
					description: item.description,
					value: item.value,
				});
			});

			transformedRequest.dwellings[0].policyOption.cycleEquipments = cycleItems;
		} else {
			delete transformedRequest.dwellings[0].policyOption.cycleEquipments;
		}

		return transformedRequest;
	}

	function updateSumInsured(transformedRequest, userInput) {
		var homeForm = userInput.homeForm,
			dwellingsInfo = transformedRequest.dwellings[0];
		if (!homeForm) {
			return transformedRequest;
		}

		//over write sum insured from quote page
		if (
			homeForm.confirmYourSumsInsured &&
			homeForm.confirmYourSumsInsured.yourBuildingSumInsured
		) {
			dwellingsInfo.buildingSumInsured =
				homeForm.confirmYourSumsInsured.yourBuildingSumInsured;
		} else {
			if (
				homeForm.yourBuilding &&
				homeForm.yourBuilding.buildingSumInsured
			) {
				dwellingsInfo.buildingSumInsured =
					homeForm.yourBuilding.buildingSumInsured;
			} else if (
				homeForm.rapidEstimate &&
				homeForm.rapidEstimate.buildingInsureAmount
			) {
				dwellingsInfo.buildingSumInsured =
					homeForm.rapidEstimate.buildingInsureAmount;
			} else {
				dwellingsInfo.buildingSumInsured = 0;
			}
		}
		//over write sum insured from quote page
		if (
			homeForm.confirmYourSumsInsured &&
			homeForm.confirmYourSumsInsured.yourContentsSumInsured
		) {
			dwellingsInfo.contentSumInsured =
				homeForm.confirmYourSumsInsured.yourContentsSumInsured;
		} else {
			if (
				homeForm.yourContents &&
				homeForm.yourContents.contentsSumInsured
			) {
				dwellingsInfo.contentSumInsured =
					homeForm.yourContents.contentsSumInsured;
			} else if (
				homeForm.rapidEstimate &&
				homeForm.rapidEstimate.contentInsureAmount
			) {
				dwellingsInfo.contentSumInsured =
					homeForm.rapidEstimate.contentInsureAmount;
			} else {
				dwellingsInfo.contentSumInsured = 0;
			}
		}

		return transformedRequest;
	}

	function updateBuildingDetails(transformedRequest, userInput) {
		if (!userInput.homeForm) {
			return transformedRequest;
		}

		if (userInput.homeForm.buildingDetails) {
			var slope =
				transformedRequest.dwellings[0].locationProperty.isLandSloped;
			if (slope === "flat") {
				transformedRequest.dwellings[0].locationProperty.isLandSloped =
					"flat";
			} else {
				transformedRequest.dwellings[0].locationProperty.isLandSloped =
					"sloped";

				transformedRequest.dwellings[0].locationProperty.slopeType = slope;
			}
		}

		return transformedRequest;
	}

	function updatePersonContactDetails(transformedRequest, userInput) {
		if (!userInput.homeForm) {
			return transformedRequest;
		}

		var homeForm = userInput.homeForm;

		if (
			homeForm.letsGetStarted &&
			homeForm.letsGetStarted.personOrCompany
		) {
			var isCompany = homeForm.letsGetStarted.personOrCompany != "person";
		} else {
			//dont do transofrmation if personOrCompany is not present
			return transformedRequest;
		}

		if (isCompany) {
			// aboutTheCompany
			var aboutTheCompany = homeForm.aboutTheCompany;
			var aboutCompanyContact = homeForm.aboutCompanyContact;
			var companyContactContact = homeForm.companyContactContact;

			if (
				aboutTheCompany &&
				aboutCompanyContact &&
				companyContactContact
			) {
				var policyHolders = [];

				var _authorisedPerson = util.deepClone(aboutCompanyContact);
				_authorisedPerson.contactType = "person";
				_authorisedPerson.primaryAddress = util.deepClone(
					companyContactContact.companyContactResidentialAddress
				);
				_authorisedPerson.emailAddress1 =
					companyContactContact.emailAddress1;
				_authorisedPerson.primaryPhone =
					companyContactContact.primaryPhone;
				_authorisedPerson.contactNumber =
					companyContactContact.contactNumber;
				_authorisedPerson = constructPhoneNumberObject(
					_authorisedPerson
				);
				delete _authorisedPerson.address;

				var _contact = util.deepClone(aboutTheCompany);
				_contact.contactType = "company";
				_contact.primaryPhone = "work";
				_contact.authorisedPersons = [
					{
						person: _authorisedPerson,
					},
				];
				_contact.primaryAddress = util.deepClone(
					_contact.companyAddress
				);
				_contact.passwordQuestion =
					companyContactContact.passwordQuestion;
				_contact.passwordAnswer = companyContactContact.passwordAnswer;
				delete _contact.address;

				policyHolders.push({
					contact: _contact,
					mainHolder: true,
				});

				if (
					homeForm &&
					homeForm.companyContactContact &&
					homeForm.companyContactContact
						.companyContactMailingPreference
				) {
					transformedRequest.documentDeliveryMethod =
						homeForm.companyContactContact.companyContactMailingPreference;
					delete transformedRequest.policyHolders[0].contact
						.companyContactMailingPreference;
				}

				transformedRequest.policyHolders = policyHolders;
			}
		} else {
			var mainPolicyHolder = homeForm.mainPolicyHolder;
			var mainPolicyHolderContact = homeForm.mainPolicyHolderContact;

			if (mainPolicyHolder && mainPolicyHolderContact) {
				var policyHolders = [];

				//create main policy holder
				var _contact = Object.extend(
					mainPolicyHolder,
					mainPolicyHolderContact
				);
				_contact.contactType = "person";
				//_contact.primaryAddress = util.deepClone(_contact.address);
				_contact.primaryAddress = util.deepClone(
					transformedRequest.policyHolders[0].contact.primaryAddress
				);
				delete _contact.address;

				var _mainPolicyHolder = {
					contact: _contact,
					mainHolder: true,
				};

				policyHolders.push(_mainPolicyHolder);

				//check for addition policy holders
				if (
					homeForm.additionalPolicyHolders &&
					homeForm.additionalPolicyHolders.policyHolders &&
					homeForm.additionalPolicyHolders.policyHolders.length > 0
				) {
					var _additionalPolicyHolders =
						homeForm.additionalPolicyHolders.policyHolders;

					_additionalPolicyHolders.forEach(function (
						policyHolderItem
					) {
						var _contact = util.deepClone(policyHolderItem);
						_contact.contactType = "person";
						_contact.primaryAddress = util.deepClone(
							_contact.address
						);
						delete _contact.address;
						var _additionalPolicyHolder = {
							contact: _contact,
							mainHolder: false,
						};
						policyHolders.push(_additionalPolicyHolder);
					});
				}

				//update convictions for all and mobile number
				policyHolders.map(function (policyHolderItem) {
					policyHolderItem.contact = constructPhoneNumberObject(
						policyHolderItem.contact
					);
					policyHolderItem.contact = constructConvictionHistoryObject(
						policyHolderItem.contact
					);

					return policyHolderItem;
				});

				if (
					homeForm &&
					homeForm.mainPolicyHolderContact &&
					homeForm.mainPolicyHolderContact
						.personContactMailingPreference
				) {
					transformedRequest.documentDeliveryMethod =
						homeForm.mainPolicyHolderContact.personContactMailingPreference;
					delete transformedRequest.policyHolders[0].contact
						.personContactMailingPreference;
				}

				transformedRequest.policyHolders = policyHolders;
			}
		}

		/** required for saving/retrieving the policy */
		if (userInput.email) {
			if (
				userInput.homeForm.tellUsABitMore &&
				userInput.homeForm.tellUsABitMore.yourEmailAddress
			) {
				transformedRequest.policyHolders[0].contact.emailAddress1 =
					userInput.homeForm.tellUsABitMore.yourEmailAddress;
				transformedRequest.email =
					userInput.homeForm.tellUsABitMore.yourEmailAddress;
			} else if (
				userInput.homeForm.mainPolicyHolderContact &&
				userInput.homeForm.mainPolicyHolderContact.emailAddress1
			) {
				transformedRequest.policyHolders[0].contact.emailAddress1 =
					userInput.homeForm.mainPolicyHolderContact.emailAddress1;
				transformedRequest.email =
					userInput.homeForm.mainPolicyHolderContact.emailAddress1;
			} else {
				transformedRequest.policyHolders[0].contact.emailAddress1 =
					userInput.email;
				transformedRequest.email = userInput.email;
			}
		} else {
			if (
				userInput.homeForm.tellUsABitMore &&
				userInput.homeForm.tellUsABitMore.yourEmailAddress
			) {
				if (transformedRequest.policyHolders[0].contact.emailAddress1) {
					//use the existing if available
				} else {
					transformedRequest.policyHolders[0].contact.emailAddress1 =
						userInput.homeForm.tellUsABitMore.yourEmailAddress;
					transformedRequest.email =
						userInput.homeForm.tellUsABitMore.yourEmailAddress;
				}
			}
		}

		return transformedRequest;
	}

	function constructPhoneNumberObject(contactInfo) {
		if (contactInfo) {
			if (!contactInfo.primaryPhone) {
				contactInfo.primaryPhone = "work";
			}

			switch (contactInfo.primaryPhone) {
				case "mobile":
					contactInfo.cellPhone = contactInfo.contactNumber;
					break;
				case "home":
					contactInfo.homePhone = contactInfo.contactNumber;
					break;
				case "work":
				default:
					contactInfo.workPhone = contactInfo.contactNumber;
					break;
			}
		}
		return contactInfo;
	}

	function constructConvictionHistoryObject(contactInfo) {
		if (contactInfo) {
			if (contactInfo.tenYears_chargedOrConvictedOffences == "yes") {
				contactInfo.hasConviction = "yes";
			} else if (
				contactInfo.tenYears_chargedOrConvictedOffences == "no"
			) {
				contactInfo.hasConviction = "no";
			} else {
				contactInfo.hasConviction = "unknown";
			}

			delete contactInfo.tenYears_chargedOrConvictedOffences;

			if (
				contactInfo &&
				contactInfo.tenYears_chargedOrConvictedOffencesDetails &&
				contactInfo.tenYears_chargedOrConvictedOffencesDetails.length >
					0
			) {
				contactInfo.dwellingHistory = [];

				contactInfo.tenYears_chargedOrConvictedOffencesDetails.forEach(
					function (incident) {
						contactInfo.dwellingHistory.push({
							pattern: incident.description,
							eventMonth: incident.month.value,
							year: parseInt(incident.year.value),
						});
					}
				);
				delete contactInfo.tenYears_chargedOrConvictedOffencesDetails;
			}
		}

		return contactInfo;
	}

	function updateCordelInfo(transformedRequest) {
		if (quoteOptions.getSelectedQuoteResultForPayment())
			transformedRequest.dwellings[0].cordelInfo = quoteOptions.getSelectedQuoteResultForPayment().cordelInfo;

		return transformedRequest;
	}

	function updateConfirmedValue(transformedRequest, userInput) {
		if (!userInput.homeForm) {
			return transformedRequest;
		}

		var confirmYourSumsInsured = userInput.homeForm.confirmYourSumsInsured;
		if (confirmYourSumsInsured) {
			if (confirmYourSumsInsured.generalPortableContentsLimit) {
				transformedRequest.dwellings[0].generalPortableContents =
					confirmYourSumsInsured.generalPortableContentsLimit;
			}
		}

		var confirmYourOptionalBenefits =
			userInput.homeForm.confirmYourOptionalBenefits;
		if (confirmYourOptionalBenefits) {
			if (confirmYourOptionalBenefits.accdLossDmgCoverBuilding) {
				transformedRequest.dwellings[0].policyOption.isBuildingAccidentalDamage = true;
			}
			if (confirmYourOptionalBenefits.accdLossDmgCoverContents) {
				transformedRequest.dwellings[0].policyOption.isContentsAccidentalDamage = true;
			}
			if (confirmYourOptionalBenefits.domesticWrkCompCover) {
				transformedRequest.dwellings[0].policyOption.isContentsDomesticWorkerComp = true;
			} else {
				transformedRequest.dwellings[0].policyOption.isContentsDomesticWorkerComp = false;
			}
		}

		return transformedRequest;
	}

	// !imp - transform the quote to use company contact and transforms only if company data is not available
	function updateRequoteCompanyContactForBlank(
		transformedRequest,
		userInput
	) {
		if (!userInput.homeForm) {
			return transformedRequest;
		}

		var homeForm = userInput.homeForm;

		//check if person or company data is available
		if (
			homeForm.letsGetStarted &&
			homeForm.letsGetStarted.personOrCompany
		) {
			var isCompany = homeForm.letsGetStarted.personOrCompany != "person";
		} else {
			//dont do transofrmation if personOrCompany is not present
			return transformedRequest;
		}

		if (isCompany) {
			//check if company contact details are available
			var aboutTheCompany = homeForm.aboutTheCompany;
			var aboutCompanyContact = homeForm.aboutCompanyContact;
			var companyContactContact = homeForm.companyContactContact;
			if (
				aboutTheCompany &&
				aboutCompanyContact &&
				companyContactContact
			) {
				//if data is available dont do anything
			} else {
				// create default data for company contact
				var _contact = transformedRequest.policyHolders[0].contact;
				_contact.contactType = "company";
				_contact.primaryPhone = "work";
				_contact.authorisedPersons = [
					{
						person: {
							contactType: "person",
							primaryAddress: _contact.primaryAddress,
						},
					},
				];

				transformedRequest.policyHolders[0] = {
					mainHolder: true,
					contact: _contact,
				};
			}
		}

		return transformedRequest;
	}

	function updatePropertyDetails(transformedRequest, userInput) {
		if (!userInput.homeForm && !userInput.homeForm.tellUsAboutTheBuilding) {
			return transformedRequest;
		}

		if (
			!userInput.homeForm.tellUsAboutTheBuilding.isHomeElevated ||
			userInput.homeForm.tellUsAboutTheBuilding.isHomeElevated ==
				"notasked"
		) {
			transformedRequest.dwellings[0].isGroundLevelElevated = "no";
		} else {
			transformedRequest.dwellings[0].isGroundLevelElevated = "yes";
		}

		//update cyclone standard based on the yearHomeBuilt
		var yearBuilt = userInput.homeForm.tellUsAboutTheBuilding.yearHomeBuilt;

		if (yearBuilt == 19801989) {
			//don't change user selection
		} else if (yearBuilt == 19901999) {
			transformedRequest.dwellings[0].isCycloneStandardlyBuilt = true;
		} else if (yearBuilt > 1999 && yearBuilt < 2100) {
			transformedRequest.dwellings[0].isCycloneStandardlyBuilt = true;
		} else {
			transformedRequest.dwellings[0].isCycloneStandardlyBuilt = false;
		}
		// transformedRequest.dwellings[0].isCycloneStandardlyBuilt

		return transformedRequest;
	}

	//updates the email
	function updateEmail(transformedRequest, userInput) {
		if (
			userInput.homeForm &&
			userInput.homeForm.tellUsABitMore &&
			userInput.homeForm.tellUsABitMore.yourEmailAddress
		) {
			transformedRequest.email =
				userInput.homeForm.tellUsABitMore.yourEmailAddress;
		} else {
			//set email from maincontact if not available in tellUsABitMore
			if (
				userInput.homeForm &&
				userInput.homeForm.mainPolicyHolderContact &&
				userInput.homeForm.mainPolicyHolderContact.emailAddress1
			) {
				transformedRequest.email =
					userInput.homeForm.mainPolicyHolderContact.emailAddress1;
			}
		}

		if (
			userInput.homeForm &&
			userInput.homeForm.tellUsABitMore &&
			userInput.homeForm.tellUsABitMore.promotionalCode
		) {
			transformedRequest.campaignCode =
				userInput.homeForm.tellUsABitMore.promotionalCode;
		}

		return transformedRequest;
	}

	//contains the logic for isInsuredsOverTheAge
	function determineIsInsuredsOverTheAge(transformedRequest, userInput) {
		if (
			userInput.homeForm &&
			userInput.homeForm.tellUsAboutInsured &&
			userInput.homeForm.tellUsAboutInsured.dobOldestInsured
		) {
			transformedRequest.isInsuredsOverTheAge =
				moment().diff(
					moment(
						userInput.homeForm.tellUsAboutInsured.dobOldestInsured,
						"DD/MM/YYYY"
					),
					"years"
				) >= 50;
		}
		return transformedRequest;
	}

	function updatePolicyAddress(transformedRequest, userInput) {
		var postalAddress = storage.getItem("policy-address");

		if (
			angular.isDefined(userInput.homeForm.mainPolicyHolderContact) ||
			angular.isDefined(userInput.homeForm.companyContact)
		) {
			if (transformedRequest.postalAddress !== null) {
				transformedRequest.policyAddress =
					transformedRequest.postalAddress;
			} else {
				var isPostalOption = true;
				if (
					userInput.homeForm.letsGetStarted.personOrCompany ==
					"person"
				) {
					isPostalOption =
						userInput.homeForm.mainPolicyHolderContact
							.personContactSamePostalAddress;
				} else {
					isPostalOption = angular.isDefined(
						userInput.homeForm.companyContact
					)
						? userInput.homeForm.companyContact
								.companyContactSamePostalAddress
						: true;
				}

				if (Object.keys(postalAddress).length > 0 && !isPostalOption) {
					transformedRequest.policyAddress = postalAddress;
				}
			}
		} else {
			if (Object.keys(postalAddress).length > 0) {
				transformedRequest.policyAddress = postalAddress;
			}
		}

		delete transformedRequest.postalAddress;
		return transformedRequest;
	}

	function updateWebBots(transformedRequest, userInput) {
		if (
			angular.isDefined(userInput.homeForm.isSyntheticTransaction_Ext) &&
			angular.isDefined(userInput.homeForm.syntheticSource_Ext)
		) {
			transformedRequest.IsSyntheticTransaction_Ext =
				userInput.homeForm.isSyntheticTransaction_Ext == "true"
					? true
					: false;
			transformedRequest.SyntheticSource_Ext =
				userInput.homeForm.syntheticSource_Ext;
		}

		return transformedRequest;
	}

	function transform(userInput) {
		var transformedRequest = jsonMapper.transform(
			userInput,
			structureQuoteMapping
		);
		transformedRequest = UpdateAlarmType(transformedRequest, userInput);
		transformedRequest = updateCoverType(transformedRequest, userInput);
		transformedRequest = updatePropertyDetails(
			transformedRequest,
			userInput
		);
		transformedRequest = updateMortgagees(transformedRequest, userInput);

		transformedRequest = UpdateRentDefault(transformedRequest, userInput);

		transformedRequest = UpdateCycles(transformedRequest, userInput);
		transformedRequest = updateDwellingHistory(transformedRequest);
		transformedRequest = updateSumInsured(transformedRequest, userInput);

		transformedRequest = updateProductCode(transformedRequest, userInput);
		transformedRequest = updateBuildingDetails(
			transformedRequest,
			userInput
		);
		transformedRequest = updatePersonContactDetails(
			transformedRequest,
			userInput
		);

		transformedRequest = updateCordelInfo(transformedRequest);
		transformedRequest = updateConfirmedValue(
			transformedRequest,
			userInput
		);

		transformedRequest = updateRequoteCompanyContactForBlank(
			transformedRequest,
			userInput
		);

		transformedRequest = updateEmail(transformedRequest, userInput);

		transformedRequest = determineIsInsuredsOverTheAge(
			transformedRequest,
			userInput
		);

		transformedRequest = updatePolicyAddress(transformedRequest, userInput);
		transformedRequest = updateWebBots(transformedRequest, userInput);
		return transformedRequest;
	}

	return {
		transform: transform,
	};
}
